import { render, staticRenderFns } from "./BasicPricing.vue?vue&type=template&id=0f23ce1a&scoped=true&"
import script from "./BasicPricing.vue?vue&type=script&lang=js&"
export * from "./BasicPricing.vue?vue&type=script&lang=js&"
import style0 from "./BasicPricing.vue?vue&type=style&index=0&id=0f23ce1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23ce1a",
  null
  
)

export default component.exports